import { createSlice } from "@reduxjs/toolkit";
import deleteConsultationCharges from "@custom/rtk-apis/billing/consultation/deleteConsultationCharges";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const deleteConsultationChargesSlice = createSlice({
  name: "deleteConsultationChargesSlice",
  initialState,
  reducers: {
    clearDeleteConsultationCharges: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteConsultationCharges.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteConsultationCharges.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteConsultationCharges.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteConsultationChargesSlice.reducer;
export const { clearDeleteConsultationCharges } = deleteConsultationChargesSlice.actions;
